import {DateTime} from 'luxon'

import {getDealerTimezone} from './timezone'

// Parses appointment date/time to DateTime objects using dealer's locale timezone
export function parseAppointmentDateTime(
  date: string,
  startTime: string,
  endTime: string,
  locale = 'es',
): {startDate: DateTime; endDate: DateTime} {
  const [startHour, startMinute] = startTime.split(':').map(Number)
  const [endHour, endMinute] = endTime.split(':').map(Number)

  const timezone = getDealerTimezone(locale)

  // Parse date string (yyyy-MM-dd format) in dealer's timezone
  const baseDate = DateTime.fromFormat(date, 'yyyy-MM-dd', {zone: timezone})
  const startDate = baseDate.set({hour: startHour, minute: startMinute, second: 0, millisecond: 0})
  const endDate = baseDate.set({hour: endHour, minute: endMinute, second: 0, millisecond: 0})

  return {
    startDate,
    endDate,
  }
}
